import {ACTIONS} from './constants';

import _ from 'underscore';

export type Cells = Record<string, number[]>;
// 	[y: string]: number[];

export type State = {
	all: boolean;
	cells: Cells;
	columnCount: number;
	columns: string[];
	count: number;
	inSingleColumn: false | string;
	inSingleRow: false | number;
	loose: boolean;
	rowCount: number;
	rows: number[];
};

export type Action =
	| {type: typeof ACTIONS.RESET}
	| {type: typeof ACTIONS.SET_ALL; all: boolean}
	| {
			type: typeof ACTIONS.SET_CELLS;
			cells: Cells;
			hasColumns: boolean;
			hasRows: boolean;
	  }
	| {
			type: typeof ACTIONS.SET_COLUMNS;
			columns: string[];
			hasRows: boolean;
			hasSelections: boolean;
	  }
	| {
			type: typeof ACTIONS.SET_COUNT;
			count: number;
			singleColumn: string | false;
			singleRow: number | false;
	  }
	| {
			type: typeof ACTIONS.SET_ROWS;
			rows: number[];
			hasColumns: boolean;
			hasSelections: boolean;
	  };

export const initialState: State = {
	all: false,
	cells: {},
	columnCount: 0,
	columns: [],
	count: 0,
	inSingleColumn: false,
	inSingleRow: false,
	loose: false,
	rowCount: 0,
	rows: [],
};

const reducer = (state: State, action: Action) => {
	switch (action.type) {
		case ACTIONS.RESET: {
			return initialState;
		}
		case ACTIONS.SET_ALL: {
			return {
				...initialState,
				count: state.count,
				all: action.all,
			};
		}
		case ACTIONS.SET_COUNT: {
			return {
				...state,
				count: action.count,
				inSingleColumn: action.singleColumn,
				inSingleRow: action.singleRow,
			};
		}
		case ACTIONS.SET_ROWS: {
			const rows = action.rows;
			const rowCount = rows.length;
			const columns = action.hasColumns ? state.columns : [];
			const columnCount = columns.length;
			return {
				...state,
				all: false,
				cells: action.hasSelections ? state.cells : {},
				columnCount,
				columns,
				loose: action.hasSelections,
				rowCount,
				rows,
			};
		}
		case ACTIONS.SET_COLUMNS: {
			const columns = action.columns;
			const columnCount = columns.length;
			const rows = action.hasRows ? state.rows : [];
			const rowCount = rows.length;
			return {
				...state,
				all: false,
				cells: action.hasSelections ? state.cells : {},
				columnCount,
				columns,
				loose: action.hasSelections,
				rowCount,
				rows,
			};
		}
		case ACTIONS.SET_CELLS: {
			const columns = action.hasColumns ? state.columns : [];
			const columnCount = columns.length;
			const rows = action.hasRows ? state.rows : [];
			const rowCount = rows.length;
			return {
				...state,
				all: false,
				cells: action.cells,
				columnCount,
				columns,
				loose: !_.isEmpty(action.cells),
				rowCount,
				rows,
			};
		}
	}
};

export default reducer;
